/* eslint-disable no-undef */
class FeaturedContentCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500
        },
        loop: true,
        mode: 'snap',
        initial: 0,
        slides: { perView: 1.5, spacing: 15 },
        breakpoints: {
          '(min-width: 769px)': {
            slides: { perView: 2.35, spacing: 20 }
          }
        }
      },
      [window.BAO.carousel.useInitialised()]
    )
  }
}

if (!customElements.get('featured-content-carousel')) {
  customElements.define('featured-content-carousel', FeaturedContentCarousel)
}
